import { JSX } from 'react';

import { Text } from '@videoblocks/design-system';

export const UpgradePlanHeader = (): JSX.Element => {
    return (
        <div className="w-full text-center">
            <Text asChild fontSize="3xl" fontWeight="semibold" className="m-0 mb-4">
                <h1>Upgrade your plan. Maximize your workflow.</h1>
            </Text>
            <Text fontSize="base" fontWeight="regular" className="m-0">
                Charged amount will be prorated according to your current plan so you won’t have to pay extra.
            </Text>
        </div>
    );
};
